var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 38,
    viewBox: "0 0 41 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79111 26.2592C0.916212 27.2267 0.47876 28.2098 0.47876 29.1877C0.47876 33.6063 9.31632 37.7455 20.4974 37.7455C31.6784 37.7455 40.516 33.6063 40.516 29.1877C40.516 28.2098 40.0785 27.2267 39.2036 26.2592C34.8864 29.0842 28.0747 30.8175 20.4922 30.8175C12.9097 30.8175 6.09793 29.0842 1.7807 26.2592M39.2088 16.0715C34.8916 18.8965 28.0799 20.6298 20.4974 20.6298C12.9149 20.6298 6.10314 18.8965 1.79111 16.0715C0.911004 17.039 0.47876 18.0221 0.47876 19C0.47876 23.4186 9.31632 27.5527 20.4974 27.5527C31.6784 27.5527 40.516 23.4135 40.516 19C40.516 18.0221 40.0785 17.039 39.2036 16.0715M20.5026 17.3702C31.6836 17.3702 40.5212 13.2309 40.5212 8.81232C40.5212 4.3937 31.6784 0.259644 20.5026 0.259644C9.32674 0.259644 0.483968 4.3937 0.483968 8.81232C0.483968 13.2309 9.32153 17.3702 20.5026 17.3702Z",
    fill: "#040000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointList);
export default __webpack_public_path__ + "static/media/pointList.5086f6b647da56c3202a2a50650ba278.svg";
export { ForwardRef as ReactComponent };